// extracted by mini-css-extract-plugin
export default {"container":"messages-container_container__2AmkD","messages":"messages-container_messages__3rUZr","message":"messages-container_message__1NwL_"};